module.exports = __webpack_public_path__ + "img/196.db4cd6e5.jpg";